import Footer from "./parts/footer"
import HeaderInternal from "./parts/header-internal"

function Congratulation() {
    return (
        <>
            <HeaderInternal />
            <div className="container w-full max-w-screen-sm m-auto my-16">
                <h1 className="text-3xl text-center mb-9">Вітаємо, ваша заявка прийнята</h1>
                <p className="text-2xl text-center mb-9">Лишились питання? Телефонуйте</p>
                <a href="tel:+380672230179" className="text-2xl block font-light phone_sell_clk text-center mb-9">+38 (067)
                    223 01 79</a>
                <a href="/" className="text-center block w-full">Повернутись на сайт</a>
            </div>
            <Footer/>
        </>

    )
}

export default Congratulation;